export enum USER_GROUP_TYPE {
  STARTUP = 1,
  INVESTOR = 2,
  SME = 3,
  INCUBATOR = 4,
  INSTITUTION = 5,
}
